import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { AddSecondaryApplicationPage } from 'features/addSecondaryApplication'
import { z } from 'zod/v4'

const checkoutReturnSearchSchema = z.object({
  checkout_session_id: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/workspaces/start')({
  component: AddSecondaryApplicationPage,
  validateSearch: checkoutReturnSearchSchema,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Create Workspace'),
      },
    ],
  }),
})
